<template>
  <div class="home">
    <Login :revalidateUser="revalidateUser" :previousRoute="previousRoute" v-if="accessConfig.loginFirst && !useUnifiedLogReg" />
    <LoginRegister :revalidateUser="revalidateUser" :previousRoute="previousRoute" v-if="accessConfig.loginFirst && useUnifiedLogReg" />
    <!-- <Footer /> -->
  </div>
</template>
<script>
import Login from '@/components/home/Login.vue';
import Footer from '@/components/general/Footer.vue';
import api from '@/services/api';

import LoginRegister from '@/components/home/LoginRegister.vue';

let _revalidateUser = false;
let _previousRoute = {};

export default {
  name: 'Home',
  components: { Login, Footer, LoginRegister },

  data() {
    return {
      template: null,
      accessConfig: null,
      revalidateUser: false,
      previousRoute: {},
    };
  },
  computed: {
    useUnifiedLogReg() {
      return this.$store.state.template.useUnifiedLoginRegister ? true : false;
    },
  },
  beforeRouteEnter(to, from, next) {
    // console.log('ROUTE');
    //console.log('Home Route: ', from, to, window.location.search );
    next((vm) => {
      vm.prevRoute = from;
      // console.log('vm.prevRoute', vm.prevRoute);
      if (vm.prevRoute.name && vm.prevRoute.name != 'Error' && vm.prevRoute.name != 'Home' && vm.prevRoute.name != 'Register') {
        // console.log('HOME  revalidateUser : ');
        //console.log('Home _revalidateUser: ', vm.prevRoute);
        _previousRoute = vm.prevRoute;
        _revalidateUser = true;
      }
    });
  },
  beforeMount() {
    this.template = this.$store.state.template.home;
    this.accessConfig = this.$store.state.template.accessConfig;
    //console.log('loginFirst: ' + this.accessConfig.loginFirst);

    if (this.accessConfig.preLogged && this.$store.state.user.token && this.$store.state.user.id) {
      this.$router.push({
        name: this.accessConfig.firstPage,
        params: this.accessConfig.firstPageParams ?? null,
      });
    } else if (this.accessConfig.loginFirst === false) {
      //Send login
      //console.log('Login Anonimo');
      if (this.accessConfig.allowAnonimous) {
        api
          .post(`event/${this.$store.state.eventId}/loginAnon`, {
            //email: this.username?this.username:null,
            //name: this.name?this.name:'Anonymous',
          })
          .then((response) => {
            //console.log('Login RESPONSE', { response });
            this.$store.commit({
              type: 'setUser',
              userData: response.data,
            });
            if (this.accessConfig.landingFirst) {
              this.$router.push({
                name: 'LandingPage',
              });
            } else if (this.accessConfig.loginPageAnonimous) {
              this.$router.push({
                name: 'Login',
              });
            } else {
              this.$router.push({
                name: this.accessConfig.firstPage,
                params: this.accessConfig.firstPageParams ?? null,
              });
            }
          })
          .catch((err, data) => {
            console.error(err);
          });
      } else {
        if (this.accessConfig.landingFirst) {
          this.$router.push({
            name: 'LandingPage',
          });
        } else {
          this.$router.push({
            name: this.accessConfig.firstPage,
            params: this.accessConfig.firstPageParams ?? null,
          });
        }
      }
    } else {
      if (this.accessConfig.integration === 'Access') {
        this.$router.push({
          name: this.accessConfig.integration,
        });
      }
      // this.$router.push({
      //   name: 'Login',
      // });
    }
  },
  mounted() {
    if (this.$route.params.to) {
      this.revalidateUser = true;
      this.previousRoute = this.$route.params.to;
    } else {
      this.revalidateUser = _revalidateUser;
      this.previousRoute = _previousRoute;
    }
    //console.log('this.previousRoute',this.previousRoute);
  },
};
</script>
<style lang="scss">
.home {
  // background-color: var(--background-color);
  position: absolute;
  inset: 0 0 auto 0;
  min-height: 100dvh;
  // padding-bottom: 5%;
}

@include media('<=tablet') {
  .home {
    display: flex;
    flex-direction: column;
  }
}
</style>
